(function () {
  var KEY = 'blore-foods-compare';
  var MAX = 3;

  function getEntries() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || '[]');
    } catch (error) {
      return [];
    }
  }

  function saveEntries(entries) {
    localStorage.setItem(KEY, JSON.stringify(entries));
    document.dispatchEvent(new CustomEvent('compare:updated', { detail: { entries: entries } }));
  }

  function hasId(entries, id) {
    return entries.some(function (entry) {
      return entry.id === id;
    });
  }

  function toggle(id, handle) {
    var entries = getEntries();
    if (hasId(entries, id)) {
      entries = entries.filter(function (entry) {
        return entry.id !== id;
      });
    } else {
      if (entries.length >= MAX) entries = entries.slice(1);
      entries.push({ id: id, handle: handle });
    }
    saveEntries(entries);
  }

  function clearAll() {
    saveEntries([]);
  }

  function updateToggleButtons(entries) {
    document.querySelectorAll('[data-compare-toggle]').forEach(function (button) {
      var active = hasId(entries, button.dataset.productId);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
  }

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currency });
    } catch (error) {
      return (cents / 100).toFixed(2);
    }
  }

  function renderTray(entries) {
    var trays = document.querySelectorAll('[data-compare-tray]');
    if (!trays.length) return;

    trays.forEach(function (tray) {
      tray.hidden = entries.length === 0;
    });
    if (entries.length === 0) return;

    // Placeholder chips while product details load
    var placeholders = entries
      .map(function () {
        return (
          '<div class="compare-tray__item" aria-hidden="true">' +
          '<span class="skeleton skeleton--line skeleton--w-80"></span>' +
          '<span class="skeleton skeleton--line skeleton--w-40"></span>' +
          '</div>'
        );
      })
      .join('');
    trays.forEach(function (tray) {
      tray.innerHTML =
        '<div class="compare-tray__head"><h2>Compare (' +
        entries.length +
        '/' +
        MAX +
        ')</h2></div>' +
        '<div class="compare-tray__grid" role="status" aria-label="Loading products">' +
        placeholders +
        '</div>';
    });

    Promise.all(
      entries.map(function (entry) {
        return fetch('/products/' + entry.handle + '.js')
          .then(function (response) {
            return response.ok ? response.json() : null;
          })
          .catch(function () {
            return null;
          });
      }),
    ).then(function (products) {
      var items = products
        .filter(Boolean)
        .map(function (product) {
          return (
            '<div class="compare-tray__item">' +
            '<p class="compare-tray__name">' +
            product.title +
            '</p>' +
            '<p class="compare-tray__price">' +
            formatMoney(product.price) +
            '</p>' +
            '<a href="' +
            product.url +
            '" class="compare-tray__link">View</a>' +
            '</div>'
          );
        })
        .join('');

      trays.forEach(function (tray) {
        tray.innerHTML =
          '<div class="compare-tray__head">' +
          '<h2>Compare (' +
          entries.length +
          '/' +
          MAX +
          ')</h2>' +
          '<button type="button" class="btn btn--ghost btn--sm" data-compare-clear>Clear</button>' +
          '</div>' +
          '<div class="compare-tray__grid">' +
          items +
          '</div>';

        var clearButton = tray.querySelector('[data-compare-clear]');
        clearButton?.addEventListener('click', clearAll);
      });
    });
  }

  function refresh() {
    var entries = getEntries();
    updateToggleButtons(entries);
    renderTray(entries);
  }

  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('compare:updated', refresh);

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-compare-toggle]');
    if (!button) return;
    event.preventDefault();
    toggle(button.dataset.productId, button.dataset.productHandle);
  });
})();
